var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPills(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4d7c27"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2b4a11"
    },
    d: "M497.447,341.237L383.564,227.354l-35.204,30.787L215.093,126.309l-34.506,154.784l-27.298,17.798 L348.979,494.58C418.13,467.611,472.66,411.448,497.447,341.237z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M184.889,312.889L184.889,312.889c-23.564,0-42.667-19.103-42.667-42.667V156.444 c0-23.564,19.103-42.667,42.667-42.667l0,0c23.564,0,42.667,19.103,42.667,42.667v113.778 C227.556,293.786,208.453,312.889,184.889,312.889z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M227.556,156.444c0-23.564-19.103-42.667-42.667-42.667s-42.667,19.103-42.667,42.667v55.884h85.333 V156.444z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D0D1D3"
    },
    d: "M227.556,156.444c0-23.564-19.103-42.667-42.667-42.667c-0.048,0-0.095,0.003-0.143,0.003v98.547 h42.81V156.444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF314F"
    },
    d: "M142.222,212.328v57.894c0,23.564,19.103,42.667,42.667,42.667s42.667-19.103,42.667-42.667v-57.894 H142.222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A30F44"
    },
    d: "M184.746,212.328v100.559c0.048,0,0.095,0.003,0.143,0.003c23.564,0,42.667-19.103,42.667-42.667 V212.33h-42.81V212.328z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M379.225,222.808L379.225,222.808c17.479,15.803,18.839,42.784,3.034,60.263l-76.305,84.397 c-15.803,17.479-42.784,18.837-60.263,3.034l0,0c-17.479-15.803-18.839-42.784-3.034-60.263l76.305-84.397 C334.764,208.363,361.744,207.005,379.225,222.808z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M242.655,310.239c-15.803,17.479-14.445,44.46,3.034,60.263 c17.479,15.803,44.46,14.445,60.264-3.034l37.478-41.453l-63.298-57.229L242.655,310.239z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D0D1D3"
    },
    d: "M244.991,369.838c0.234,0.221,0.459,0.448,0.698,0.664c17.479,15.803,44.46,14.445,60.263-3.034 l37.478-41.451l-31.965-28.901L244.991,369.838z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF314F"
    },
    d: "M343.431,326.016l38.828-42.944c15.803-17.479,14.445-44.46-3.034-60.263s-44.46-14.445-60.264,3.034 l-38.828,42.944L343.431,326.016z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A30F44"
    },
    d: "M379.313,222.892l-67.846,74.223l31.965,28.901l38.828-42.944 C398.034,265.623,396.705,238.707,379.313,222.892z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPills);
export default __webpack_public_path__ + "static/media/pills.c8f2aa6db18b40f6708defff92c0b7a0.svg";
export { ForwardRef as ReactComponent };